import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalConfirmComponent implements OnInit {

  @ViewChild('modalConfirm') public modalConfirm: NgbModal;

  closeResult: string;
  modalReference: NgbModalRef;

  @Input() title: string = 'Cancellation Waiver';
  @Input() yesText: string ='Yes, please add cancellation waiver.';
  @Input() noText: string = 'No, please confirm my reservation without cancellation waiver.';
  @Output() userSelection:EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private modalService: NgbModal,
  ) { }

  public yes(): void {
    this.userSelection.emit(true);
  }
  public no(): void {
    this.userSelection.emit(false);
  }

  public openConfirmModal() {
    this.modalReference= this.modalService.open(
      this.modalConfirm, {
        windowClass: 'modal-confirm',
        size: 'lg',
        keyboard: false,
        backdrop: false,
        centered: true
      }
    );
  }

  public closeConfirmModal(){
    this.modalReference.close();
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/modal-confirm/modal-confirm.component.ts